<template>
  <div class="navigation">
    <div class="navigation__inner">
      <div class="navigation__user">
        <div class="navigation__avatar" />
        <div class="navigation__name">
          <span v-line-clamp:20="2">{{ `${user.firstName} ${user.lastName}` }}</span>
          <span class="navigation__role">{{ user.roleName }}</span>
        </div>
      </div>
      <ul class="navigation__nav">
        <li
          v-for="{ slug, name, href, count } in menuItems"
          :key="slug"
          :class="['navigation__item']"
        >
          <a v-if="href" :href="href" target="_blank" class="navigation__link">
            <span class="navigation__linkSpan">
              {{ name }}
            </span>
          </a>
          <nuxt-link v-else :to="slug" class="navigation__link">
            <span class="navigation__linkSpan">
              {{ name }} <span class="navigation__linkNumber" v-if="count">{{ count }}</span>
              <span
                v-if="name === 'Powiadomienia' && unreadNotifications"
                class="navigation__itemLabel"
              >
                {{ unreadNotifications }}
              </span>
            </span>
          </nuxt-link>
        </li>
        <li class="navigation__item">
          <div class="navigation__link">
            <button class="navigation__linkSpan" @click="$auth.logout()">Wyloguj się</button>
          </div>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex';

export default {
  name: 'Navigation',
  props: {
    menuItems: {
      type: Array,
      default: () => [],
    },
  },
  computed: {
    ...mapState('auth', ['user']),
    ...mapGetters('notifications', ['unreadNotifications']),
    path() {
      return this.$route.path;
    },
  },
  methods: {
    charCount(str, char) {
      return str.split(char).length - 1;
    },
  },
};
</script>

<style lang="scss">
.navigation {
  $root: &;
  background-color: $cWhite;

  &__inner {
    position: relative;
    z-index: 1;
  }

  &__user {
    padding: 2rem 2.5rem;
    display: flex;
    align-items: center;
  }

  &__avatar {
    height: 3.5rem;
    width: 3.5rem;
    min-width: 3.5rem;
    border-radius: 5px;
    margin-right: 1rem;
    border: 1px solid $cAddLight;
    background-size: cover;
    background-position: center;
    background-repeat: no-repeat;
    background-image: url('../static/images/avatar.png');
  }

  &__name {
    font-size: 1.4rem;
    line-height: 1.8rem;
    color: $cMainDark;
    display: flex;
    flex-direction: column;
    font-weight: 600;
    overflow: hidden;
  }

  &__role {
    color: $cAddDark02;
    font-size: 1.2rem;
    line-height: 1.5rem;
    font-weight: 400;
  }

  &__nav {
    padding-bottom: 2rem;
    border-top: 1px solid $cAddLight;
  }

  &__item {
    position: relative;
    cursor: pointer;
  }

  &__link {
    position: relative;
    display: flex;
    align-items: center;
    padding: 0.4rem 0 0.4rem 2.5rem;
    font-size: 1.6rem;
    line-height: 3.2rem;
    color: $cMainLight;
    border-top: 1px solid $cWhite;
    border-bottom: 1px solid $cWhite;
    border-right: 1px solid $cWhite;
    transition: color $tr, border $tr;

    &:before {
      content: '';
      position: absolute;
      left: 0;
      top: 0;
      height: 100%;
      width: 100%;
      background-image: linear-gradient(-89deg, #ffffff 0%, #f7f8fc 100%);
      opacity: 0;
      transition: opacity $tr;
    }

    &:after {
      content: '';
      position: absolute;
      left: 0;
      top: 0;
      height: 100%;
      width: 3px;
      background-color: $cSec;
      border-radius: 0 2px 2px 0;
      opacity: 0;
      transition: opacity $tr;
    }

    &.nuxt-link-exact-active,
    &:hover {
      border-right: 1px solid $cWhite;

      &:before {
        opacity: 1;
      }

      #{$root}__link {
        color: $cMainDark;
      }
    }

    &.nuxt-link-exact-active {
      &:after {
        opacity: 1;
      }
    }
  }

  &__linkSpan {
    display: flex;
    align-items: center;
    position: relative;
  }

  &__itemLabel {
    position: absolute;
    left: calc(100% + 1.3rem);
    top: 50%;
    transform: translateY(-50%);
    width: 2rem;
    height: 2rem;
    padding-left: 1px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 1.1rem;
    letter-spacing: 0.05em;
    font-weight: 800;
    color: $cWhite;
    background-color: $cSec;
    border-radius: 50%;
  }

  &__linkNumber {
    font-size: 1rem;
    background-color: $cSec;
    border-radius: 50%;
    color: $cWhite;
    font-weight: 700;
    margin-left: 1rem;
    padding: 0.3rem;
    width: 2rem;
    display: inline-flex;
    height: 2rem;
    justify-content: center;
    align-items: center;
  }
}
</style>
